const BOOTSTRAP_WAIT_MS = 5000
const BOOTSTRAP_POLL_MS = 50

export function createDropdown(element) {
  if (!element || !window.bootstrap || typeof window.bootstrap.Dropdown !== 'function') {
    return null
  }

  return new window.bootstrap.Dropdown(element)
}

export function createCollapse(element) {
  if (!element || !window.bootstrap || typeof window.bootstrap.Collapse !== 'function') {
    return null
  }

  return new window.bootstrap.Collapse(element)
}

export function whenBootstrapReady(callback) {
  if (window.bootstrap) {
    callback(window.bootstrap)
    return () => {}
  }

  let intervalId
  const timeoutId = window.setTimeout(() => {
    window.clearInterval(intervalId)
  }, BOOTSTRAP_WAIT_MS)

  intervalId = window.setInterval(() => {
    if (window.bootstrap) {
      window.clearInterval(intervalId)
      window.clearTimeout(timeoutId)
      callback(window.bootstrap)
    }
  }, BOOTSTRAP_POLL_MS)

  return () => {
    window.clearInterval(intervalId)
    window.clearTimeout(timeoutId)
  }
}
